import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { getCurrentUaeDate } from "@utils/date-time";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const VesselDetails = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.vessel-details`)}
        className="grid-cols-1 lg:grid-cols-2"
      >
        <div className="col-start-1 lg:col-start-1">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.RTA>
            testId="nomination-rta-input"
            name={FORM_FIELDS.RTA}
            type="date-picker"
            label={t(`${LANG_BASE}.fields.rta`)}
            onFieldChange={updateFormData}
            combinedInput={true}
            required
            minDate={getCurrentUaeDate()}
          />
        </div>
        <div className="col-start-1 lg:col-start-2">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.ETA>
            testId="nomination-eta-input"
            name={FORM_FIELDS.ETA}
            type="date-picker"
            label={t(`${LANG_BASE}.fields.eta`)}
            onFieldChange={updateFormData}
            combinedInput={true}
            required
            minDate={getCurrentUaeDate()}
          />
        </div>
        <div className="col-start-1 lg:col-start-1">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.CALL_SIGN>
            testId="nomination-call-sign-input"
            name={FORM_FIELDS.CALL_SIGN}
            type="text"
            label={t(`${LANG_BASE}.fields.call-sign`)}
            onFieldChange={updateFormData}
            enforceUppercase
            disabled
          />
        </div>
        <div className="col-span-1 lg:col-start-2">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.PREVIOUS_VESSEL_NAME>
            testId="nomination-previous-vessel-name-input"
            name={FORM_FIELDS.PREVIOUS_VESSEL_NAME}
            type="text"
            maxChars={50}
            label={t(`${LANG_BASE}.fields.previous-vessel-name`)}
            onFieldChange={updateFormData}
            enforceUppercase
          />
        </div>
      </FormSection>
    </FormProvider>
  );
};

export default VesselDetails;
